import React from "react";
import { useTranslation } from "react-i18next";
import {
  StyledModalBody,
  StyledModal,
  StyledModalFooter,
} from "../styledComponents/StyledModals";
import { StyledButton } from "../styledComponents/CommonStyledComponents";

export const RollingLimitRegimeConfirmDialog = ({
  showModal,
  targetRegime,
  handleProceed,
  handleCancel,
  skin,
  resetDate,
}) => {
  const { t } = useTranslation("");

  const confirmLabel =
    targetRegime === "gross"
      ? t("label_confirm_switch_to_gross", { resetDate: resetDate || "" })
      : t("label_confirm_switch_to_nett", { resetDate: resetDate || "" });

  return (
    <StyledModal isOpen={showModal}>
      <StyledModalBody register rollingLimits>
        {confirmLabel}
      </StyledModalBody>
      <StyledModalFooter>
        <StyledButton
          banktransfer
          pub={skin === "pub"}
          onClick={() => handleProceed()}
        >
          {t("label_yes")}
        </StyledButton>
        <StyledButton
          dialog
          pub={skin === "pub"}
          onClick={() => handleCancel()}
        >
          {t("label_no")}
        </StyledButton>
      </StyledModalFooter>
    </StyledModal>
  );
};
